import React from 'react';
import { fieldNames } from '../../../common/config';
import { Form } from 'antd';
import { useShutdownInitiators } from '../../../../../shared/api/queries/shutdownInitiators';
import { getOptionsBySelect } from '../../lib/getOptionsBySelect';
import DropdownSelect from '../../../../../../../components/dropdownSelect';

const initiatorsFieldName = fieldNames.initiators;
const cityFieldName = fieldNames.city;
const FormItem = Form.Item;

const InitiatorsField = ({
  form,
  editMode = false,
  shutdown,
  initialValueInit,
}) => {
  const cityId = editMode
    ? shutdown?.alertCity?.id
    : form.getFieldValue(cityFieldName);
  console.log(shutdown, 'shutdown');

  const { data = [], isFetching } = useShutdownInitiators(cityId, {
    staleTime: Infinity,
    enabled: Boolean(cityId),
  });

  const initialValue = data?.length && editMode ? initialValueInit : [];

  const options = getOptionsBySelect(data);

  const isDisabled = isFetching || !cityId;

  return (
    <FormItem
      label="Инициаторы"
      style={{ margin: 0 }}
    >
      {form.getFieldDecorator(initiatorsFieldName, {
        initialValue,
        rules: [
          { required: true, message: 'Укажите инициаторов', type: 'array' },
        ],
      })(
        <DropdownSelect
          options={options}
          disabled={isDisabled}
          loading={isFetching}
          multiple
        />
      )}
    </FormItem>
  );
};

export default InitiatorsField;
